import React from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({ data }) => {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Hero Image - Full Width, Focused on Faces */}
      <section style={{ position: 'relative', width: '100%', height: '55vh', minHeight: '450px', maxHeight: '600px', overflow: 'hidden' }}>
        <img
          src={data.heroImage}
          alt="Hero"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center 35%',
          }}
        />
      </section>

      {/* Hero Content - Below Image */}
      <section style={{ background: 'var(--bg-page)', padding: '80px 0' }}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-title" style={{ marginBottom: '32px', lineHeight: '1.1' }}>
              {data.title}
            </h1>
            <p
              className="body-large"
              style={{
                color: 'var(--text-secondary)',
                marginBottom: '40px',
                fontSize: '1.35rem',
                lineHeight: '1.6',
                maxWidth: '700px',
                margin: '0 auto 40px',
              }}
            >
              {data.subtitle}
            </p>
            <button onClick={scrollToPricing} className="btn-primary" style={{ fontSize: '1.1rem', padding: '1.2em 2em' }}>
              {data.ctaText} ({data.ctaPrice})
              <ArrowRight size={20} style={{ marginLeft: '8px' }} />
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
